const { default: axiosIns } = require('@/libs/axios')

const AdsService = {
  // GET - AdApiController
  async getAd(adId, adGroupId, catalogSetId, accountId) {
    return axiosIns
      .get(`/ads/${adId}?accountId=${accountId}`, {
        params: {
          adGroupId,
          catalogSetId,
        },
      }).then(response => response.data)
  },
  async sanitazeUrl(url = '') {
    return axiosIns.get('/ads/url', {
      params: {
        url,
      },
    }).then(response => response.data)
  },
  async getHeatmap(model, accountId) {
    return axiosIns.get(`/ads/heatmap?accountId=${accountId}&adId=${model.adId}&dateRange=${model.dateRange}`).then(response => response.data)
  },
  // POST - AdApiController
  async createDisplayAd(subTypeId, model, accountId) {
    return axiosIns.post(`/ads/display?accountId=${accountId}`, model, {
      params: {
        subTypeId,
      },
    }).then(response => response.data)
  },
  async createVideoAd(model, accountId) {
    return axiosIns.post(`/ads/video?accountId=${accountId}`, model).then(response => response.data)
  },
  async createNativeAd(model, accountId) {
    return axiosIns.post(`/ads/native?accountId=${accountId}`, model).then(response => response.data)
  },
  async createDisplayCatalogItemAds(model, accountId) {
    return axiosIns.post(`/ads/display/catalogItem?accountId=${accountId}`, model).then(response => response.data)
  },
  async createCatalogProductAds(model, accountId) {
    return axiosIns.post(`/ads/native/product?accountId=${accountId}`, model).then(response => response.data)
  },
  async createCatalogSetAd(model, accountId) {
    return axiosIns.post(`/ads/native/set?accountId=${accountId}`, model).then(response => response.data)
  },
  async createCatalogSetDisplayAd(model, accountId) {
    return axiosIns.post(`/ads/display/set?accountId=${accountId}`, model).then(response => response.data)
  },
  async duplicateAd(ad, accountId) {
    return axiosIns.post(`/ads/${ad.adId}?accountId=${accountId}`, ad).then(response => response.data)
  },
  async saveCompanionAd(ad, accountId) {
    return axiosIns.post(`/ads/companion?accountId=${accountId}`, ad).then(response => response.data)
  },
  // PUT - AdApiController
  async editDisplayAd(displayAd, accountId) {
    return axiosIns.put(`/ads/display/${displayAd.adId}?accountId=${accountId}`, displayAd).then(response => response.data)
  },
  // Download AI HTML as ZIP
  async downloadAIHtmlAsZip(payload, accountId) {
    return axiosIns.post(`/ads/ai/download-rar?accountId=${accountId}`, payload, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  },
  async generateAIAd(payload, accountId) {
    return axiosIns.post(`/ads/ai/generate?accountId=${accountId}`, payload).then(response => response.data)
  },
  async uploadHtmlZip(formData, accountId) {
    return axiosIns.post(`/upload/html?accountId=${accountId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(response => response.data)
  },
}

export default AdsService
